var _         = require('underscore');
var $         = require('jquery');
var Core      = require('../core/core.js');
var SplitItem = require('./split__item.js');

/**
 * Creates a Split
 *
 * @class
 */

class Split extends Core {

    _defaults() {
        return {
            target: '.js-Split',
            fields: {}
        };
    }

    constructor(options) {
        super(options);

        console.assert(options.width.length >= 2 && options.width.length <= 3, "Split controller currently only supports 2-way and 3-way split");

        this.template = `
            <div class='editor__split'>
                <div class='editor__split__left js-editor__split__left'></div>
                ${options.width.length == 3 ? `<div class='editor__split__middle js-editor__split__middle'></div>` : ''}
                <div class='editor__split__right js-editor__split__right'></div>
            </div>
        `;

        super.render();

        // set width of split windows:
        console.assert(options.width.reduce((a,b) => a+b, 0) == 100, "Split controller: sum of all window width needs to equal 100 %");

        $(".js-editor__split__left", this.$el).css("right", 100 - options.width[0] + "%");
        if (options.width.length == 3) {
            $(".js-editor__split__middle", this.$el).css("left", options.width[0] + "%");
            $(".js-editor__split__middle", this.$el).css("right", options.width[2] + "%");
            $(".js-editor__split__right", this.$el).css("left", 100 - options.width[2] + "%");
        } else {
            $(".js-editor__split__right", this.$el).css("left", 100 - options.width[1] + "%");
        }

    }

    /**
     * Add Left Side
     */
    addLeftSplitItem(){
        return new SplitItem({
            target: $('.js-editor__split__left', this.$el)
        })
    }

    addMiddleSplitItem(){
        return new SplitItem({
            target: $('.js-editor__split__middle', this.$el)
        })
    }

    /**
     * Add Right Side
     */
    addRightSplitItem(){
        return new SplitItem({
            target: $('.js-editor__split__right', this.$el)
        })
    }

}
module.exports = Split;